@import "tailwindcss";

/* Custom theme configuration for three.pm */
@theme {
  /* Keep the existing black/white minimal branding */
  --color-primary: #000000;
  --color-secondary: #ffffff;

  /* Font family - using system fonts like the original */
  --font-family-sans: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* Base layer overrides */
@layer base {
  body {
    @apply font-sans antialiased;
  }
}
